import React from 'react';
import PropTypes from 'prop-types';

export class ContentHeightMonitor extends React.Component {
  state = {
    height: 0
  };
  constructor(props) {
    super(props);
    this.mutationObserver = new MutationObserver(this.updateHeight);
    this.resizeListener = window.addEventListener('resize', this.updateHeight);
    this.node = document.getElementsByTagName('html')[0];
  }
  updateHeight = () => {
    const height = this.node.getBoundingClientRect().height;
    if (this.state.height !== height) {
      this.setState({ height });
      this.props.heightChange(height);
    }
  };
  componentDidMount() {
    this.updateHeight();
    this.mutationObserver.observe(this.node, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }
  componentWillUnmount() {
    this.mutationObserver.disconnect();
    window.removeEventListener('resize', this.resizeListener);
  }
  render() {
    return this.props.children;
  }
}

ContentHeightMonitor.propTypes = {
  heightChange: PropTypes.func
};
ContentHeightMonitor.defaultProps = {
  heightChange: height => {
    if (window && window.parent) {
      const targetOrigin =
        window.location.protocol + '//' + window.location.host;
      window.parent.postMessage(
        JSON.stringify({ type: 'heightChanged', payload: height + 40 }),
        targetOrigin
      );
    }
  }
};
